module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAACCAYAAAEbeA0BAAAAAXNSR0IArs4c6QAAAClJREFUCB1j+P///1YGEAAy/oMJMAMmAuJAAUQZVGIrTBQLvQWkBhkAAGCxPpiGAPW7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/invitation-card-line.png
// module id = 868
// module chunks = 124